import Vue from 'vue';
import Axios from 'axios';

export default Vue.extend({
    data () {
      return {
        locations: [],
      }
    },

  created(){
    this.student_location();
  },

  methods:{
    async student_location(){
      let token =  localStorage.getItem("jwt");
      let userId = localStorage.getItem("userId");
      if (token && userId) {            
        console.log("token",token);            
        const auth = {
            headers: {authorization: token} 
        }
        let resultSubject = await this.$http.get('/job/fetchState', auth)
          console.log("res",resultSubject);
          console.log("resp",resultSubject.data);
          if(resultSubject.status === 200 && resultSubject.data.message === "State found"){
            this.locations = resultSubject.data.state;
          }
      }
                  //  console.log("statewise_percentage",result.data);
                  //  console.log("statewise_percentage",this.locations);
    }
  }
})
